import { MEDIA_NAME } from '../types/types';
import bridgeSktMap from '../../infra/bridge/skt';
import bridgeKtMap from '../../infra/bridge/kt';
import bridgeLguMap from '../../infra/bridge/lgu';
import { useRecoilState } from 'recoil';
import * as Atom from '../recoil/index';
import useToast from '../hooks/useToast';

export const useBridge = (media?: string) => {
  const [user] = useRecoilState(Atom.userInfo);
  const { addToast } = useToast();
  media = media || user.media;
  const version = user.version;

  const errorHandler = () => {
    addToast('PASS앱 업데이트가 필요합니다');
  };

  return media === MEDIA_NAME.SKT
    ? bridgeSktMap(version, errorHandler)
    : media === MEDIA_NAME.KT
    ? bridgeKtMap(version, errorHandler)
    : media === MEDIA_NAME.LGU
    ? bridgeLguMap(version, errorHandler)
    : bridgeSktMap(version, errorHandler);
};
